import React from 'react';
import PropTypes from 'prop-types';
import {CardList, CardListItem} from 'client/generic/CardList/CardList.react';
import LoadingIndicator from 'client/generic/LoadingIndicator.react';
import Topics from './Topics/Topics.react';
import Themes from './Table/Themes.react';
import SubjectLineItem from './Table/SubjectLineItem.react';
import studentUtil from './Student.util';
import './student-topics.scss';
import './topic-guide-table.scss';

export default class StudentTopics extends React.Component {
  static propTypes = {
    scopeParameters: PropTypes.object
  };

  getTopics({sort = 'best'}) {
    let params = this.props.scopeParameters;
    if (sort === 'best') {
      params = {...params, sortDirection: '-'};
    }

    if (!this.props.scopeParameters || !studentUtil.areStudentGuideLevelMetricsReady(params)) {
      return <LoadingIndicator />;
    }

    const heading = sort === 'best' ? 'Best Three Topics' : 'Toughest Three Topics';

    const topics = studentUtil
      .getStudentGuideLevelMetrics(params)
      .getCollection()
      .filter((guideLevel) => guideLevel.isTopic())
      .take(3);

    return (
      <CardListItem>
        <Topics heading={heading} topics={topics} />
      </CardListItem>
    );
  }

  getGuideTable() {
    if (
      !this.props.scopeParameters ||
      !studentUtil.areStudentSubjectMetricsReady(this.props.scopeParameters)
    ) {
      return <LoadingIndicator />;
    }

    return (
      <div className='topic-table'>
        <div className='topic-table-row'>
          <div className='topic-table-row__cell--header topic-table-row__cell topic-table-row__cell--large'>
            Guide Level
          </div>
          <div className='topic-table-row__cell--header topic-table-row__cell'>Time Spent</div>
          <div className='topic-table-row__cell--header topic-table-row__cell topic-table-row__cell--medium'>
            Unique Questions Answered
          </div>
          <div className='topic-table-row__cell--header topic-table-row__cell'>
            Percent Complete
          </div>
          <div className='topic-table-row__cell--header topic-table-row__cell'>Accuracy</div>
          <div className='topic-table-row__cell--header topic-table-row__cell'>Mastery Level</div>
        </div>
        <ul className='guide-table-list-group'>
          {studentUtil.getStudentSubjectMetrics(this.props.scopeParameters).map((subject) => {
            /*
              We explicitly take the first here because subjects do not yet have > 1 guide.

              Intentionally not doing this in the model because I don't want this to be a future
              stealth bug.

              NOTE: Also being used in StudyGuideStore.js -- Update that too if you're changing this.
            */
            const guideForSubject = subject.getGuides().first();
            const themeList = guideForSubject?.getSortedThemes?.();

            if (!themeList || themeList?.isEmpty?.()) {
              return null;
            }

            return [
              <SubjectLineItem subject={subject} key={subject.getId()} />,
              <Themes
                key={`subject-${subject.getId()}-themes`}
                themes={themeList}
                guide={guideForSubject}
              />
            ];
          })}
        </ul>
      </div>
    );
  }

  render() {
    return (
      <div className='student-topics'>
        <div className='student-topics-summary'>
          <CardList>
            {this.getTopics({sort: 'best'})}
            {this.getTopics({sort: 'worst'})}
          </CardList>
        </div>
        <div className='student-topics-guides'>{this.getGuideTable()}</div>
      </div>
    );
  }
}
